import React from 'react';
import { useParams } from 'react-router-dom';
import useDocumentTitle from '../../../components/useDocumentTitle';
import CampaignCreationForm from '../FNFT/CampaignCreationForm';

const DeployFNFT = () => {
    useDocumentTitle('Deploy FNFT');
    const { tokenId, collectionAddress } = useParams();

    return (
        <div>
            <CampaignCreationForm collectionAddress={collectionAddress} id={tokenId} />
            {/* {loader} */}
        </div>
    );
};

export default DeployFNFT;
